
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import { Report } from "@/types";

@Component
export default class DisplayReports extends Vue {
  @Prop() reports!: Report[];

  @Prop() loading!: boolean;

  isLoading: boolean = false;

  selected: any = [];

  pagination: any = {
    sortBy: "createdAt"
  };

  headers: any = [
    { text: "Date de création", value: "createdAt" },
    { text: "Reporter", value: "reporterId" },
    { text: "Signalement", value: "reporter" }
  ];

  search: String = "";

  @Watch("loading", { immediate: true })
  handleLoadingChange(value: boolean) {
    this.isLoading = value;
  }

  toggleAll() {
    if (this.selected.length) this.selected = [];
    else this.selected = this.reports.slice();
  }

  changeSort(column: string) {
    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
  }
}
